module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iX4TL"))).then(() => parcelRequire('1iHdE'));